export const demoCredentials = {
  email: "demo@qualt.io",
  password: "QualtioDemo2026!",
} as const;
